export function assertNever(value: never): never {
  throw new Error(
    `Exhaustive check expected "never", but received: "${JSON.stringify(value)}"`,
  );
}
